// assets/pdp.js

document.addEventListener('DOMContentLoaded', () => {
  const main = document.getElementById('MainContent');
  if (!main) return;

  const template = main.getAttribute('data-template') || '';
  const isProduct = template.includes('product');

  initFadeIn();
  initAccordions();

if (isProduct) {
  initMiniBagModal();
  initAjaxAddToCart();
  initImageSwap(); 
}

});

/* -------------------------------
   Fade-in on scroll
-------------------------------- */

function initFadeIn() {
  /** @type {NodeListOf<HTMLElement>} */
  const fadeEls = document.querySelectorAll('[data-lux-fade]');
  if (!fadeEls.length) return;

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = /** @type {HTMLElement} */ (entry.target);
          el.classList.add('lux-fade-in');
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.15 }
  );

  fadeEls.forEach(el => observer.observe(el));
}

/* -------------------------------
   Accordion
-------------------------------- */

function initAccordions() {
  /** @type {NodeListOf<HTMLElement>} */
  const accordions = document.querySelectorAll('[data-lux-accordion]');
  if (!accordions.length) return;

  accordions.forEach(acc => {
    const toggle = acc.querySelector('.lux-accordion__toggle');
    const content = acc.querySelector('.lux-accordion__content');

    if (!(toggle instanceof HTMLElement)) return;
    if (!(content instanceof HTMLElement)) return;

    toggle.addEventListener('click', () => {
      const isOpen = acc.classList.contains('open');
      if (isOpen) {
        acc.classList.remove('open');
        content.style.maxHeight = '';
      } else {
        acc.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* -------------------------------
   Mini-bag modal
-------------------------------- */

/** @type {HTMLElement | null} */
let miniBagModal = null;
/** @type {HTMLElement | null} */
let miniBagBackdrop = null;
/** @type {HTMLElement | null} */
let miniBagBox = null;
/** @type {HTMLElement | null} */
let miniBagContent = null;

function initMiniBagModal() {
  const modal = document.querySelector('[data-lux-mini-bag]');
  if (!(modal instanceof HTMLElement)) return;

  miniBagModal = modal;
  miniBagBackdrop = modal.querySelector('.lux-mini-bag-modal__backdrop');
  miniBagBox = modal.querySelector('[data-lux-mini-bag-box]');
  miniBagContent = modal.querySelector('[data-lux-mini-bag-content]');

  modal.addEventListener('click', e => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    if (
      target.hasAttribute('data-lux-mini-bag-close') ||
      (miniBagBackdrop && target === miniBagBackdrop)
    ) {
      closeMiniBag();
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeMiniBag();
    }
  });
}

function openMiniBag() {
  if (!miniBagModal) return;
  miniBagModal.classList.add('open');
  miniBagModal.setAttribute('aria-hidden', 'false');
}

function closeMiniBag() {
  if (!miniBagModal) return;
  miniBagModal.classList.remove('open');
  miniBagModal.setAttribute('aria-hidden', 'true');
}

/* -------------------------------
   AJAX Add to Cart + modal content
-------------------------------- */

function initAjaxAddToCart() {
  const atcBtn = document.querySelector('[data-lux-atc]');
  const formEl = document.querySelector('#lux-pdp-form');

  if (!(atcBtn instanceof HTMLElement)) return;
  if (!(formEl instanceof HTMLFormElement)) return;

  atcBtn.addEventListener('click', async () => {
    const formData = new FormData(formEl);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      if (!res.ok) throw new Error('Add to cart failed');

      /** @type {any} */
      const data = await res.json();
      updateMiniBagContent(data);
      openMiniBag();
    } catch (err) {
      console.error(err);
    }
  });
}

/**
 * @param {any} item
 */
function updateMiniBagContent(item) {
  if (!miniBagContent || !item) return;

  const line = item;
  const image = line.image || null;
  const title = line.product_title || '';
  const variantTitle = line.variant_title || '';
  const price = line.final_line_price || line.line_price || line.price;

  miniBagContent.innerHTML = `
    <div class="lux-mini-bag-line">
      ${
        image
          ? `<img src="${image}" alt="${title}" class="lux-mini-bag-line__image">`
          : ''
      }
      <div class="lux-mini-bag-line__info">
        <div class="lux-mini-bag-line__title">${title}</div>
        ${
          variantTitle
            ? `<div class="lux-mini-bag-line__variant">${variantTitle}</div>`
            : ''
        }
        <div class="lux-mini-bag-line__price">${formatMoney(price)}</div>
      </div>
    </div>
    <div class="lux-mini-bag-actions">
      <a href="/cart" class="lux-mini-bag-btn lux-mini-bag-btn--primary">View bag</a>
      <a href="/collections/all" class="lux-mini-bag-btn lux-mini-bag-btn--secondary">Continue browsing</a>
    </div>
  `;
}

/**
 * @param {number | string} cents
 */
function formatMoney(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const value = (Number(cents) / 100).toFixed(2);
  return `$${value}`;
}

/* -------------------------------
   Hero Image Swap (Thumbnails)
-------------------------------- */

function initImageSwap() {
  const thumbs = document.querySelectorAll('.lux-pdp-media__thumb');
  if (!thumbs.length) return;

  const hero = document.getElementById('lux-hero-image');
  if (!hero) return;

  thumbs.forEach(button => {
    button.addEventListener('click', () => {
      const newSrc = button.getAttribute('data-image');
      if (newSrc) {
        hero.setAttribute('src', newSrc);
      }
    });
  });
}
